import antdEnUS from 'ant-design-vue/es/locale-provider/id_ID';
import dayjsLocale from 'dayjs/locale/id';
import momentEnCA from 'moment/dist/locale/en-ca';
import data from '../json/id.json';

const components = {
  antLocale: antdEnUS,
  momentName: 'eu',
  momentLocale: momentEnCA,
  dayjsName: 'id',
  dayjsLocale
};

export default {
  ...components,
  ...data
};
